import { Component } from "react";
import ReactDOM from "react-dom";

const MODAL_ROOT_ID = "et--portal-root";
// You need to put a an element w/ this id somewhere to render to
let modalRoot = document.getElementById(MODAL_ROOT_ID);
if (!modalRoot) {
  modalRoot = document.createElement("div");
  modalRoot.id = MODAL_ROOT_ID;
  document.body.appendChild(modalRoot);
}

class ModalStatePortal extends Component {
  static displayName = "Portal";

  el = document.createElement("div");

  componentDidMount() {
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}
export default ModalStatePortal;
